var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-lesson-course-ware"},[_c('LessonCourseware',{attrs:{"class-type-id":_vm.classTypeId,"lesson-id":_vm.lessonId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }